import { jsx as _jsx } from "react/jsx-runtime";
import CopyrightCheckerPhotoOverview from '../overzicht/CopyrightCheckerPhotoOverview';
const PhotoOverviewForwarder = (props) => {
    return _jsx(CopyrightCheckerPhotoOverview, { ...props, data: props.photos });
};
export default PhotoOverviewForwarder;
